import {
    SET_IS_AUTHORIZED,
    SET_PASSWORD_CHANGED,
    REQUEST_LOGIN,
    REQUEST_SIGNUP,
    REQUEST_LOGIN_OR_SIGNUP_SUCCESS,
    REQUEST_LOGIN_OR_SIGNUP_FAILURE,
    REQUEST_CHANGE_PASSWORD,
    SIGN_OUT
} from './constants'

export function setIsAuthorized(payload /* :boolean */) {
    return {
        type: SET_IS_AUTHORIZED,
        payload
    }
}

export function requestLogin({ email, password, remember }) {
    return {
        type: REQUEST_LOGIN,
        payload: {
            email,
            password,
            remember
        }
    }
}

export function requestSignup({ organization, email, password, origin }) {
    return {
        type: REQUEST_SIGNUP,
        payload: {
            organization,
            email,
            password,
            origin
        }
    }
}

export function signOut() {
    return {
        type: SIGN_OUT
    }
}

export function setAdmin({ admin, jwt }) {
    return {
        type: REQUEST_LOGIN_OR_SIGNUP_SUCCESS,
        payload: {
            admin,
            jwt
        }
    }
}

export function requestAuthFailure() {
    return {
        type: REQUEST_LOGIN_OR_SIGNUP_FAILURE,
        payload: {}
    }
}

export function requestChangePassword({ oldPass, newPass }) {
    return {
        type: REQUEST_CHANGE_PASSWORD,
        payload: {
            oldPass,
            newPass
        }
    }
}

export function setPasswordChanged() {
    return {
        type: SET_PASSWORD_CHANGED
    }
}
